<script>

  /**
   * 统一认证服务器地址
   */

  const ssoServer = "https://platform.ynhlminiapp.com"; // 线上环境
  const ssoServerimg = "https://platform.ynhlminiapp.com/api/file/upload"; //线上图片环境

  
  // const ssoServer ="https://platform-test.ynhlminiapp.com"; // 测试环境
  // const ssoServerimg = "https://platform-test.ynhlminiapp.com/api/file/upload"; //测试图片环境

  
  // const ssoServer ="http://192.168.8.30:10001"; // 本地环境
  // const ssoServerimg = "http://192.168.8.30:10001/api/file/upload"; //本地图片环境



  export default
  {
    ssoServer,    
    ssoServerimg
    // ssoServerLogout
    
  }

</script>



// WEBPACK FOOTER //
// src/views/Global.vue